import classNames from "classnames";
import styles from "./Email.module.scss";

type Props = {
    email: string;
    className?: string;
}

export const Email = ({email, className}: Props) => {
    return (
        email
            ? <a href={`mailto:${email}`} className={classNames(styles.email, className)}>{email}</a>
            : null
    );
}
